import { useEffect, useState } from 'react';
import { fetchScannerLibrary } from '../../services/api';

/**
 * broker|symbol -> folder name, for the instruments that sit in a folder.
 *
 * The feed carries the real account, but a folder instrument is scanner-only and
 * the operator knows it by its folder, not by the account row behind it.
 *
 * ponytail: matched without sectype — the feed rarely carries one, and a symbol
 * living twice under one broker with different sectypes is not a case we have.
 */
export default function useInstrumentFolders() {
  const [map, setMap] = useState({});

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const data = await fetchScannerLibrary();
      if (!data || cancelled) return;
      const names = Object.fromEntries(data.folders.map((f) => [f.id, f.name]));
      setMap(Object.fromEntries(
        data.instruments
          .filter((i) => i.folder_id && names[i.folder_id])
          .map((i) => [`${i.broker}|${i.symbol}`, names[i.folder_id]]),
      ));
    })();
    return () => { cancelled = true; };
  }, []);

  return map;
}
